import { useState, useCallback } from "react";

export const usePermissionModal = ({ onModalClose }) => {
  const [modalMode, setModalMode] = useState(null);
  const [selectedPermission, setSelectedPermission] = useState(null);

  const modalOpen = modalMode !== null;

  const closeModal = useCallback(() => {
    if (typeof onModalClose === "function") {
      onModalClose();
    }
    setModalMode(null);
    setSelectedPermission(null);
  }, [onModalClose]);

  const openCreateModal = useCallback(() => {
    if (typeof onModalClose === "function") {
      onModalClose();
    }
    setSelectedPermission(null);
    setModalMode("create");
  }, [onModalClose]);

  const openEditModal = useCallback((permission) => {
    setSelectedPermission(permission);
    setModalMode("edit");
  }, []);

  return {
    modalMode,
    modalOpen,
    selectedPermission,
    openCreateModal,
    openEditModal,
    closeModal,
  };
};

export default usePermissionModal;
